import { differenceInYears, startOfDay } from "date-fns";
import { parseDate } from "web_myplann/Shared/Utils/parseDate";

const MAX_AGE = 120;

export const getAgeFromDate = (
	raw: string | null | undefined,
	now: Date = new Date(),
): number | undefined => {
	const bornDate = parseDate(raw);
	if (!bornDate) return undefined;
	const years = differenceInYears(startOfDay(now), startOfDay(bornDate));
	return years > 0 && years < MAX_AGE ? years : undefined;
};
